import { removeItemInArray } from '@gcl/react-core';
import { useEffect, useState } from 'react';
import { ITagViewItem } from './TagView';

export const useLocalTags = (tags: ITagViewItem[]) => {
  const [localTags, setLocalTags] = useState<ITagViewItem[]>(tags ?? []);
  useEffect(() => {
    setLocalTags(tags);
  }, [JSON.stringify(tags)]);

  const onRemove = (index: number) => {
    setLocalTags((old) => {
      return removeItemInArray(old, index);
    });
  };
  const onAdd = (newTag: ITagViewItem) => {
    setLocalTags((oldTag) => [...oldTag, newTag]);
  };
  return {
    localTags,
    onRemove,
    onAdd,
  };
};
